export const HR_FILL_THEN_PAY_PAYMENT_PREFS_KEY = "hrFillThenPayPaymentPrefs";

export function readHrFillThenPayPaymentPrefs() {
  try {
    const raw = sessionStorage.getItem(HR_FILL_THEN_PAY_PAYMENT_PREFS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function writeHrFillThenPayPaymentPrefs(prefs) {
  try {
    sessionStorage.setItem(
      HR_FILL_THEN_PAY_PAYMENT_PREFS_KEY,
      JSON.stringify(prefs || {})
    );
  } catch {
    /* ignore */
  }
}

export function consumeHrFillThenPayPaymentPrefs() {
  const prefs = readHrFillThenPayPaymentPrefs();
  if (!prefs) return null;
  try {
    sessionStorage.removeItem(HR_FILL_THEN_PAY_PAYMENT_PREFS_KEY);
  } catch {
    /* ignore */
  }
  return prefs;
}
